import React,{Component} from 'react';
import WebHeaderInner from './WebHeaderInner.js';
import WebFooter from './WebFooter.js';
//import {Modal} from 'react-bootstrap';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
// const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_Site_Map extends Component{
  constructor(props){	
    super(props);
    this.state={    	
    }
  } 

  render()
  {
  
    document.title ="AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
      document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
	return(
		<div>	
			<WebHeaderInner />	
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="full_wt_clr_bg">
			   <div className="container web_advertise_page" >	 
			     <div className="row">
			     <div className="clr">&nbsp;</div>
			     <div className="clr">&nbsp;</div>
					<div style={{textAlign:'center'}}>
						<h1>Checkout Flow</h1><br/> 
			        	<div><img src={require('../../assets/images/check_out.png')} /></div>  
			      </div>
             </div>  
			     </div> 
			     </div>
		    <WebFooter />
     </div>
	);
  }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_Site_CheckoutFlow.js
 **/